import { PeriodOption } from "../interface/examinationSettings"

export enum ReminderContext {
    Validity = 0,
    Recertification = 1
}

export enum ReminderTiming {
    BeforeStart = 0,
    BeforeEnd = 1,
    AfterEnd = 2
}

export const PERIOD_OF_VALIDITY_OPTIONS: Record<string, PeriodOption[]> = {
    KorVila1: [
        { value: 365, labelId: "one_year" },
        { value: 183, labelId: "six_months" },
        { value: 91, labelId: "three_months" }
    ],

    KorVilaFreightTraffic: [
        { value: 365, labelId: "one_year" },
        { value: 183, labelId: "six_months" },
        { value: 91, labelId: "three_months" }
    ],

    Miljo1: [
        { value: 1865, labelId: "five_years" },
        { value: 730, labelId: "two_years" },
        { value: 365, labelId: "one_year" },
        { value: 183, labelId: "six_months" }
    ]
}

export const REMINDER_OPTIONS: PeriodOption[] = [
    { value: 91, labelId: "three_months" },
    { value: 30, labelId: "thirty_days" }
]

export const RECURRING_REMINDER_OPTIONS: PeriodOption[] = [
    { value: 10, labelId: "every_ten_days" },
    { value: 3, labelId: "every_three_days" }
]

export const getPeriodOfValidityOptions = (examType: string): PeriodOption[] => {
    return PERIOD_OF_VALIDITY_OPTIONS[examType] || PERIOD_OF_VALIDITY_OPTIONS.KorVila1
}
